export default __webpack_public_path__ + "static/media/pic1.1e7a6380.jpg";